import { memo, useMemo } from "react";
import { Label, DatePickerComponent } from "../";

const DateRangePicker = ({
  values,
  setFieldValue,
  className = "col-lg-2 col-md-6 col-12",
  customClass = "",
  showTimeSelect = true,
  startDatePlaceholder = "Pick a start date and time",
  endDatePlaceholder = "Pick an end date and time",
  dateFormat = "dd-MM-yyyy h:mm aa",
  startMaxDate = "",
}) => {
  const today = new Date();

  const startMaxDateMemo = useMemo(
    () => startMaxDate || today,
    [startMaxDate, today]
  );

  return (
    <>
      <div className={customClass}>
        <div className="date-input-box">
          <Label htmlFor="startDate" className="lead_text">
            Start Date
          </Label>
          <DatePickerComponent
            selectedDate={values.startDate}
            onChange={(date) => {
              setFieldValue("startDate", date);

              // set end date
              if (date > values?.endDate) setFieldValue("endDate", date);
            }}
            placeholderText={startDatePlaceholder}
            // minDate={startMinDate}
            maxDate={startMaxDateMemo}
            showTimeSelect={showTimeSelect}
            timeIntervals={15} // or 5, 10, 30 based on your preference
            timeFormat="HH:mm"
            isClearable={false}
            className="form-control w-100"
            dateFormat={dateFormat}
          />
        </div>
      </div>

      <div className={customClass}>
        <div className="date-input-box">
          <Label htmlFor="endDate" className="lead_text">
            End Date
          </Label>
          <DatePickerComponent
            selectedDate={values?.endDate}
            onChange={(date) => {
              setFieldValue("endDate", date);

              // set start date
              if (date < values?.startDate) setFieldValue("startDate", date);
            }}
            placeholderText={endDatePlaceholder}
            // minDate={endmindate}
            maxDate={today}
            showTimeSelect={showTimeSelect}
            timeIntervals={15}
            timeFormat="HH:mm"
            isClearable={false}
            className="form-control"
            dateFormat={dateFormat}
          />
        </div>
      </div>
    </>
  );
};

export default memo(DateRangePicker);
